export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14061.c6928cb4.jpg";